(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityBannerController', Controller);

    Controller.$inject = ['$scope', '$state', 'biaResponsibilityService', '$modal', '$stateParams', '$filter', '$timeout', '$q'];

    function Controller($scope, $state, biaResponsibilityService, $modal, $stateParams, $filter, $timeout, $q) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.priorityLevels = $scope.boxContext.BCMLookups.PriorityLevels;

        //get the list of responsibilities to be rated
        var getBIAResponsibilitiesToRate = function () {
            return biaResponsibilityService.getBIAResponsibilitiesForBUOwnerAndTaskDefinition(
                $scope.boxContext.BIAProfile.BIAProfileID,
                $scope.boxContext.BIAOwner.BIABUOwnerID,
                'NeedBIAResponsilityRating'
            )
        }

        //get the list of responsibilities to be prioritized
        var getBIAResponsibilitiesToPrioritize = function () {
            return biaResponsibilityService.getBIAResponsibilitiesForBUOwnerAndTaskDefinition(
                $scope.boxContext.BIAProfile.BIAProfileID,
                $scope.boxContext.BIAOwner.BIABUOwnerID,
                'NeedBIAResponsibilityPrioritization'
            )
        }

        //Wait for both promises to resolve before initiating the notification banner
        var promise1 = getBIAResponsibilitiesToRate();
        var promise2 = getBIAResponsibilitiesToPrioritize();

        $q.all([promise1, promise2]).then(function (data) {
            $scope.ctrlCtxt.biaResponsibilitiesToBeRated = data[0];
            $scope.ctrlCtxt.biaResponsibilitiesToBePrioritized = data[1];

            initBannersContext();
        });

        //Detect if and which notification banner to display
        var initBannersContext = function () {

            //Check and display the rating banner if there are other responsibilities (than the current one) to rate
            if ($scope.boxModel.IsRated && $scope.ctrlCtxt.biaResponsibilitiesToBeRated.length > 0) {
                $scope.showResponsibilitiesToBeRatedBanner = true;
            }

            //Check and display the prioritize banner if there are no more responsibilities to rate but pending priorization
            if ($scope.ctrlCtxt.biaResponsibilitiesToBeRated.length === 0
                && $scope.ctrlCtxt.biaResponsibilitiesToBePrioritized.length > 0) {
                $scope.showResponsibilitiesToBePrioritizedBanner = true;
            }

        }


        // List Responsibilities to Rate Modal
        $scope.showResponsibilitiesToBeRatedModal = function () {

            // Modal to show
            var modal;
            var modalScope = $scope.$new(true);

            modalScope.boxModel = $scope.boxModel;
            modalScope.boxContext = $scope.boxContext;
            modalScope.onClose = function () {
                modal.$promise.then(modal.hide);
            };

            modal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.responsibilitiesToBeRated.modal.tpl.html',
                placement: 'center'
            });

            modalScope.$on('modal.hide', function () {
                modalScope.$destroy();
            });

        };

        $scope.goToResponsibility = function (resp) {

            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility', {
                BIAProfileID: $stateParams.BIAProfileID,
                BIABUOwnerID: $stateParams.BIABUOwnerID,
                BIAResponsibilityID: resp
            });

        }


        // Prioritize BIA Resps
        $scope.prioritizeBIAResps = function () {

            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxContext.BIAResponsibilities);
            modalScope.priorityLevels = $scope.ctrlCtxt.priorityLevels;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.list.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            $scope.$on('modal.hide', function () {
                $state.go('biaProfile.edit.biaBuOwner', {
                    BIAProfileID: $stateParams.BIAProfileID,
                    BIABUOwnerID: $stateParams.BIABUOwnerID
                }, { reload: true });
            });

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

    }

})();